import React from "react";
import "./ContactMap.scss";
import Map from '../../../components/map/Map'

export default function ContactMap() {
  return (
    <section id="contact" className="section">
      <div className="container">
        <header className="section__head">
          <h2>Kontakti un atrašanās vieta</h2>
          <p className="muted">Ropažu nov., Upeslejas, Zaharijas Stopija 10</p>
        </header>

        <div className="contact">
          <div className="contact__card">
            <h3>Sazinies ar mums</h3>
            <ul className="contact__list">
              <li><span>Tālrunis:</span> +371 22 365 002</li>
              <li><span>E-pasts:</span> topringlat@gmail.com</li>
              <li><span>Adrese:</span> Rīga, Lubanas iela 78b</li>
            </ul>
            <a className="btn btn--primary" href="mailto:info@wushuclub.lv">Uzdot jautājumu</a>
          </div>

          <div className="map">
           <Map/>
          </div>
        </div>
      </div>
    </section>
  );
}
